export const showCaseDatas = [
    {id : 1 , key : "projects" , classname : "btn-proj" , name : "Projects"},
    {id : 2 , key : "tech-stack" , classname : "btn-tech" , name : "Tech Stack"}
]